module.exports = __webpack_public_path__ + "img/bg_app_small.16487fa1.svg";